
export const publicPath = process.env.NODE_ENV === 'production' ? '/assets' : '';
export const imageUrlBase = `${publicPath}/images`
